import Auth from '../services/AuthService';

export default {
    computed: {
        user: function () {
            return Auth.user;
        }
    },
};


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/Auth.js